import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';
import {Link} from 'react-router';
import {DialogRegistration} from '../model/DialogRegistration';

function PageAccessRedirectDialog({
    title,
    details,
    redirectTo,
    dismissButtonText,
    confirmButtonText,
}: PageAccessRedirectPrompt.Props) {
    const {onClose} = RsnDialog.useControls();
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader text={title} icon={{element: <RsnDialog.StatusIcon status='attention' />}} />
            <RsnDialog.Body>{details}</RsnDialog.Body>
            <RsnDialog.Footer column>
                <RsnButton.Alike intent='primary' onClick={onClose} as={Link} to={redirectTo} replace>
                    {confirmButtonText}
                </RsnButton.Alike>
                <RsnButton.Secondary onClick={onClose}>{dismissButtonText}</RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}

export namespace PageAccessRedirectPrompt {
    export interface Props {
        title: string;
        details: string;
        redirectTo: string;
        confirmButtonText: string;
        dismissButtonText: string;
    }
}

export const PromptToCompleteKyc = DialogRegistration.create({
    name: 'PromptToCompleteKyc',
    Component: () => (
        <PageAccessRedirectDialog
            title='Complete the registration'
            details='Please finish the verification process to open access to this service.'
            redirectTo='/signup/kyc'
            confirmButtonText='Continue'
            dismissButtonText='Later'
        />
    ),
});

export const FeatureDeniedSupportPrompt = DialogRegistration.create({
    name: 'FeatureDeniedSupportPrompt',
    Component: () => (
        <PageAccessRedirectDialog
            title='Oops...'
            details='For some reason, this service is not available to you right now. Please contact support for details.'
            redirectTo='/support/form'
            confirmButtonText='Contact support'
            dismissButtonText='Later'
        />
    ),
});

export const PromptToConfirmAddress = DialogRegistration.create({
    name: 'PromptToConfirmAddress',
    Component: () => (
        <PageAccessRedirectDialog
            title='Confirm the address'
            details='Please finish the verification process to open access to this service.'
            redirectTo='/address-verification'
            confirmButtonText='Confirm now'
            dismissButtonText='Later'
        />
    ),
});
